module.exports = __webpack_public_path__ + "static/media/make-resume-jj.d48dd32e.jpg";